'use strict';

define('features/vehicle-info/vehicle-info',[
  'jquery',
  'lib/services/batws',
  'lib/util/debounce',
  'components/slicker',
  'zipTools',
  'lib/util/zip',
  'disclaimers',
  'bat',
  'lib/shim/gsap',
  'lib/util/tda.config',
  'lib/page-cache',
  'lib/tda/kac',
  'features/recentVehicles',
  'ajaxOffers',
  'dealerLiveChat',
  'responsive',
  './vehicle-info.prius-prime',
  'features/ctas/index',
  'lib/scroller',
  'txt!./vehicle.trims.hbs',
  './trim.xform',
  './trim.xform.big.images',
  './trim.xform.disclaimers',
  'lib/readable-monetize',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'cookies',
  'lib/util/langFromUrl',

  // side effect includesss
  'lib/transforms/series.mapByCode',
  'Handlebars',
  'lib/helpers/ifCond', // helpers needed by the insane # of inline HBS templates in vehicle-info.js
  'lib/helpers/toJSON',
  'lib/helpers/replaceDisclaimer',
  'isInViewport',
  'h5validate',
  'dropkick'
], function (
  $,
  batws,
  debounce,
  Slicker,
  zipTools,
  zip,
  disclaimers,
  bat,
  gsap,
  tdaConfig,
  PageCache,
  kac,
  recentVehicles,
  AjaxOffers,
  dealerLiveChat,
  responsive,
  priusPrime,
  ctas,
  scroller,
  txtTrims,
  trimXform,
  trimXformBigImages,
  trimXformDisclaimers,
  readableMonetize,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext,
  cookies,
  langFromUrl
) {
  var __tmplTrims = Handlebars.compile(txtTrims);
  var __lang = langFromUrl();

  var vehicleInfo = {
    load: function () {
      vehicleInfo.init();
      /*
      BAT-3248. ADD LINKS TO SPECS INFO:
      NOTE: THE REQUEST WAS TO HAVE LINKS AT END OF SPECS PARAGRAPHS TRIGGER aa-link.
      CAVEAT: ONLY CHECKING FOR THE LAST ITEM.
      IF TDA DEVIATES FROM THIS MODEL, THIS WILL HAVE TO BE RECONSINDERED.
      TODO: move to specs drawing func
      */
      $('.specs-col-content').each(function (index, item) {
        var lastp = $(item).find('p').last();
        var lasta = lastp.find('a');
        lasta.addClass('datalayer-link');
      });

      // TODO: move to Prius JS file
      if (vehicleInfo.data.series === 'priusprime') {
        priusPrime.showSideBarLinks();
        priusPrime.buildCalculator();
      }
    },

    init: function () {
      this.$sideNav = $('.nav-vehicle-info');
      this.$header = $('#js-vi-intro');
      this.$gallery = $('#section-info-gallery');
      this.$galleryPager = $('.gallery-pager', this.$gallery);
      this.$vehicleSpecs = $('#section-vehicle-specs');
      this.$trims = $('#section-info-trims');
      this.populateData();
      this.galleryBuild();
      $('#component-offers-strip').addClass('page-vehicle-info');
      this.pageHeadLineSwitch();
      this.addCanonicalLink();
      this.enableFeatureVideo();
      this.checkCompare();
      this.checkTSS();
      this.addSpecContext();
    },

    addCanonicalLink: function () {
      $('head').append('<link rel="canonical" href="https://www.buyatoyota.com/' + tdaConfig.site.context_url + '/vehicles/' + this.data.series + '/" />');
    },

    pageHeadLineSwitch: function () {
      if (__lang === 'es') {
        $('.section-header .js-build-en').remove();
        $('.section-header .js-build-es').show();
      } else {
        $('.section-header .js-build-es').remove();
        $('.section-header .js-build-en').show();
      }
    },

    checkCompare: function () {
      $(document).on('COMPARE_FAIL', function () {
        $('#section-info-compare').remove();
        $('a[href="#section-info-compare"]').remove();
      });
    },

    checkTSS: function () {
      if (!$('#section_tss_view').length) {
        $('#tssLink').remove();
      }
    },

    // TODO: move this to CTA handling
    setLinkChanges: function () {
      var tdaCode = $('#region-name').attr('data-tda-code');
      if (tdaCode === 'SET10') {
        var $setVehicle = $('#page-vehicle-info');
        var setSeries = $setVehicle.data('series');
        var setSeriesHyphen = setSeries;
        switch (true) {
          case /hybrid/.test(setSeriesHyphen):
            setSeriesHyphen.replace('hybrid', '-hybrid');
            break;
          case /landcruiser/.test(setSeriesHyphen):
            setSeriesHyphen = 'land-cruiser';
            break;
          case /priusc/.test(setSeriesHyphen):
            setSeriesHyphen = 'prius-c';
            break;
          case /priusv/.test(setSeriesHyphen):
            setSeriesHyphen = 'prius-v';
            break;
          case /corollahatchback/.test(setSeriesHyphen):
            setSeriesHyphen = 'corolla-hatchback';
            break;
          default:
            setSeriesHyphen = setSeries;
            break;
        }
        var inventoryUrl = 'http://southeast.buyatoyota.com/' + setSeriesHyphen;
        var offersUrl = 'http://explore.setbuyatoyota.com/offers/#' + setSeries;
        var buildUrl = 'http://southeast.buyatoyota.com/' + setSeriesHyphen + '/build';
        $("a[data-destination='inventory']").attr('href', inventoryUrl);
        $("a[data-destination='offers']").attr('href', offersUrl);
        $('a.js-build-now').attr('href', buildUrl);
      }
    },

    // not yet accounted for in our newer 'per component' CTA handling
    // so this still needs to be done at the 'page' level
    handleCtasPage: function () {
      var $clickToChatCta = $("a[data-destination='live-chat']");
      var providerId = tdaConfig.chat.provider_id;
      if (($clickToChatCta.length > 0) && (providerId !== '')) {
        if (tdaConfig.tda.code === 'KAC10') {
          $clickToChatCta.addClass('etsChatButton');
          $clickToChatCta.attr('data-destination', 'live-chat-kac');
          kac.dealerChat(); // BAT-2915 KAC only Chat w/Dealer CTAs
        } else {
          dealerLiveChat.init(providerId);
        }
      }
    },

    attachListeners: function () {
      var self = this;
      // main side nav
      $('a', this.$sideNav).on('click', function (e) {
        e.preventDefault();
        var section = $(this).attr('href');
        // BAT-3173 SKIP SCROLL ANIMATION FOR BENEFITS MODAL LINK.
        if (section === '#benefits') {
          return;
        }
        var headerHeight = $('#area-header').outerHeight();
        var offset = $(section).offset().top - headerHeight;
        $('body,html').animate({
          scrollTop: offset
        }, 500, function () {
          // BAT-4196 FOCUS AFTER SPEED DIAL. focusable IS DEFINED IN tabControl.js
          $(section).find(':focusable:visible')
            .first().focus();
        });
      });

      // grid icon, destroy slideshow
      $('.js-models-grid').on('click', function (e) {
        e.preventDefault();
        var $that = $(this);
        var animateTrims = function () {
          $('.models-slideshow').animate({
            height: self.slideshowModelsGridHeight,
            opacity: 0
          }, 250, function () {
            self.slideshowModelsCurrent.slick('unslick');
            self.slideshowModelsCurrent = [];
            $that.siblings('.js-models-list').removeClass('active');
            $that.addClass('active');
            $('.models-slideshow').animate({
              opacity: 1
            }, 250);
          });
        };

        if (self.slideshowModelsCurrent.length !== 0) {
          animateTrims();
        }
      });

      // list icon, build slideshow
      $('.js-models-list').on('click', function (e) {
        e.preventDefault();
        var $that = $(this);
        var animateTrims = function () {
          $('.models-slideshow').animate({
            height: self.slideshowModelsSlideHeight,
            opacity: 0
          }, 250, function () {
            self.slideshowModelsBuild();
            $that.siblings('.js-models-grid').removeClass('active');
            $that.addClass('active');
            $('.models-slideshow').animate({
              opacity: 1
            }, 250);
          });
        };
        if (self.slideshowModelsCurrent.length === 0) {
          animateTrims();
        }
      });

      // Toggle model-items details in grid view
      $('.js-item-toggle').on('click', function (e) {
        var $trim = $('#js-template-trim-output');
        var closeOthers = function () {
          $trim.find('.model-item').removeAttr('style');
          $trim.find('.js-item-toggle').removeClass('icon-arrow-up-2').addClass('icon-arrow-down-2');
          $trim.find('.item-content:visible').collapse('toggle');
        };

        closeOthers();

        var $self = $(this);
        var $modelItem = $self.closest('.model-item');
        var $content = $modelItem.find('.item-content');
        var isContentVisible = $content.is(':visible');

        // other models

        e.preventDefault();

        if (isContentVisible) {
          $modelItem.removeAttr('style');
        } else {
          $modelItem.css('z-index', 2);
        }

        $self.toggleClass('icon-arrow-up-2', !isContentVisible);
        $self.toggleClass('icon-arrow-down-2', isContentVisible);
        $content.collapse('toggle');
      });

      if (tdaConfig.tda.code === 'WWW') {
        // Trigger click event on hidden button, when zip code input is filled out.
        // triggering the click event on this hidden button,
        // invokes the the nationalForms.initOffersForm event listener

        if (cookies.getItem('isConfirmedZip') === 'true') {
          $('#vehicle-info-zip').val(zip.getCookiedDefaultFallback());
        }
        // mobile version uses default nationalForms.initOffersForm event listener
        $('#vehicle-info-zip').on('keyup', function (e) {
          var $this = $(this);
          var siteHomePath = zipTools.getSiteHomePath();
          var maxLen = parseInt($this.attr('maxlength'));
          var myLen = $this.val().length;
          var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);

          // if in focus and user hits enter OR if maxlength is met, 'submit' zip (and not came into focus using TAB BAT-4783)
          if ($this.is(':focus') && (keyID === 13 || maxLen === myLen) && keyID !== 9) {
            bat.util.loader.showLoader();
            var newZip = $this.val();
            var series = $this.closest('.vehicle-discounts-zip-form').find('input.vehicle-series').val();

            zipTools.changeZip(undefined, newZip, siteHomePath + 'offers/' + series + '/', undefined, false); // BAT-3521
            // zipTools.changeZip(undefined, newZip, siteHomePath + 'offers/' + series + '/', undefined, true);
          }
        });
        // BAT 3520 - Resolves geolocate button on WWW vehicle info page
        $('.is-www .js-autolocate-vi').on('click', function (e) {
          e.stopPropagation();
          var siteHomePath = zipTools.getSiteHomePath();
          var series = $(this).closest('.vehicle-discounts-zip-form').find('input.vehicle-series').val();
          var geoSuccess = function (returnedZip) {
            // Need to find where siteHomePath and series are coming from
            zipTools.changeZip(undefined, returnedZip, siteHomePath + 'offers/' + series + '/', undefined, true);
          };
          zipTools.geoLocationZip.detect(geoSuccess, zipTools.reLoadDealerSearchWithoutZip);
        });
        // BAT 4783 - add geolocate keyboard handler
        $('.is-www .js-autolocate-vi').on('keyup', function (e) {
          var $this = $(this);
          var keyID = (e.charCode) ? e.charCode : ((e.which) ? e.which : e.keyCode);

          // if in focus and user hits enter OR if maxlength is met, 'submit' zip (and not came into focus using TAB BAT-4783)
          if ($this.is(':focus') && keyID === 13) {
            e.stopPropagation();
            var siteHomePath = zipTools.getSiteHomePath();
            var series = $(this).closest('.vehicle-discounts-zip-form').find('input.vehicle-series').val();
            var geoSuccess = function (returnedZip) {
              // Need to find where siteHomePath and series are coming from
              zipTools.changeZip(undefined, returnedZip, siteHomePath + 'offers/' + series + '/', undefined, true);
            };
            zipTools.geoLocationZip.detect(geoSuccess, zipTools.reLoadDealerSearchWithoutZip);
          }
        });
      }

      var sectionInView = debounce(function () {
        $.each($('.js-isinview:in-viewport(285)'), function (index, el) {
          var currId = $(el).attr('id');
          self.navUpdateCurrent(currId);
        });

        /*-------------------------------------------------------
        Handle unique 'sections'
          - offers-component (does not have an .isinview class on it, since this component is used on several pages)
          - the build section sits so far down the bottom of the page, it needs a much larger threshold
        -------------------------------------------------------*/
        var $sectionIntro = $('#section-info-intro');
        if ($sectionIntro.is(':in-viewport(285)')) {
          self.navUpdateCurrent($sectionIntro.attr('id'));
        }

        var $sectionOffers = $('#component-offers-strip');
        if ($sectionOffers.is(':in-viewport(285)')) {
          self.navUpdateCurrent($sectionOffers.attr('id'));
        }

        if (self.$gallery.is(':in-viewport(285)')) {
          self.navUpdateCurrent(self.$gallery.attr('id'));
        }

        if (self.$vehicleSpecs.is(':in-viewport(285)')) {
          self.navUpdateCurrent(self.$vehicleSpecs.attr('id'));
        }

        if (self.$trims.is(':in-viewport(285)')) {
          self.navUpdateCurrent(self.$trims.attr('id'));
        }

        var $sectionCompare = $('#section-info-compare');
        if ($sectionCompare.is(':in-viewport(285)')) {
          self.navUpdateCurrent($sectionCompare.attr('id'));
        }

        // calculate threshold specifically for the BUILD section
        var winHeight = $(window).height();
        var thirds = winHeight / 4;
        var lastThreshold = thirds * 1.9;
        var $sectionBuild = $('#section-info-build');
        if ($sectionBuild.is(':in-viewport(' + lastThreshold + ')')) {
          self.navUpdateCurrent('section-info-build');
        }
      }, 250);

      // Only invoke sectionInView if/when our side nav is visible
      var checkNavSide = debounce(function () {
        var navSideVisible = $('.cont-nav-side').is(':visible');
        $(window).off('scroll', sectionInView);
        if (navSideVisible) {
          sectionInView(); // for first page load
          $(window).on('scroll', sectionInView);
        }
      }, 250);

      checkNavSide(); // for first page load
      $(window).on('resize', checkNavSide);
    },

    navUpdateCurrent: function (section) {
      var $selector = $('.nav-vehicle-info');
      var newAnchor = $selector.find('a[href="#' + section + '"]');
      $selector.children('li').removeClass('is-current');
      newAnchor.parent('li').addClass('is-current');
    },

    // Access a built models slideshow methods & properties, using slideshowModelsCurrent
    // TODO: move slideshows outta here!
    slideshowModelsCurrent: [],
    slideshowModelsSlideHeight: 0,
    slideshowModelsGridHeight: 0,

    slideshowModelsBuild: function () {
      var self = this;
      var $scope = self.$trims;
      var modelsSlides = new Slicker({
        $slider: $('.models-slideshow .carousel-inner'),
        slickOptions: {
          mobileFirst: true,
          slide: '.model-item',
          slidesToShow: 1,
          fade: true,
          infinite: true,
          autoplay: false,
          arrows: true,
          beforeFunction: function (e, slick, currentSlide, nextSlide) {
            anAddContext(
              $scope,
              blocks.seriesBlock(self.trimsArr[nextSlide]),
              blocks.listItemBlock(nextSlide)
            );
          },

          initFunction: function () {
            var slideHeight = self.slideshowModelsSlideHeight;
            var gridHeight = self.slideshowModelsGridHeight;
            var $modelsSlideshow = $('.models-slideshow');
            if (slideHeight === 0) {
              self.slideshowModelsSlideHeight = $modelsSlideshow.outerHeight();
              var rowCount = Math.ceil($('.model-item').length / 3);
              gridHeight = rowCount * 360; // # of row * static height of a model-item
              self.slideshowModelsGridHeight = gridHeight;
            }
          },
          tablet: {
            dots: true,
            appendArrows: $('.models-slideshow'), // custom location for our custom prev/next arrows
            prevArrow: '<div class="carousel-prev datalayer-link" data-linktext="model_selector_previous"><button class="bx-prev unstyled" aria-label="show previous model"><i class="icon icon-arrow-thin-left"></i></button></div>',
            nextArrow: '<div class="carousel-next datalayer-link" data-linktext="model_selector_next"><button class="bx-next unstyled" aria-label="show next model"><i class="icon icon-arrow-thin-right"></i></button></div>'
          }
        }
      });

      // if there's only a single item, remove the grid view
      if (modelsSlides.$slider.children('.model-item').length === 1) {
        $('.js-models-list, .js-models-grid').fadeOut();
      }
      this.slideshowModelsCurrent = modelsSlides.$slider;
      self.analyticsTrims(self.trimsArr);
    },

    analyticsTrims: function (trimsArr) {
      // vehicleInfo.trimsArr defined in drawTrims
      var $scope = this.$trims;
      // default CTX on max context block (component)
      anAddContext(
        $scope,
        blocks.seriesBlock(trimsArr[0]),
        blocks.sectionBlock('Model Selector'),
        blocks.listBlock(trimsArr.length, 'carousel'),
        blocks.listItemBlock(0)
      );

      // Also need to do these after slideshow / grid view funcs have run
      anAddContext(
        $('.js-models-grid'),
        blocks.listBlock(trimsArr.length, 'grid')
      );
      anAddContext(
        $('.js-models-list'),
        blocks.listBlock(trimsArr.length, 'carousel')
      );

      // handles all links within each trim. Really only needed for grid layout,
      trimsArr.forEach(function (trim, idx) {
        anAddContext(
          $('.js-model-' + trim.series + '-' + trim.model_code),
          blocks.seriesBlock(trim),
          blocks.listItemBlock(idx)
        );
      });

      anClicks($scope);

      scroller.add($scope, {
        after: function () {
          anPageLoad($scope);
        }
      });
    },

    // TODO: move this outta here!
    galleryBuild: function () {
      var $scope = this.$gallery;
      var $galleryPagerLink = $('a', this.$galleryPager);
      $galleryPagerLink.first().addClass('active');
      // click events for gallery-pager
      $galleryPagerLink.on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        $galleryPagerLink.removeClass('active');
        $this.addClass('active');
        var slide = $this.data('slideIndex');
        $('.vehicle-info-gallery .carousel-inner').slick('slickGoTo', slide);
      });

      var gallerySlides = new Slicker({
        $slider: $('.vehicle-info-gallery .carousel-inner'),
        slickOptions: {
          // use mobileFirst: true to apply these defaults to ALL BPs. Then overwrite accordingly
          mobileFirst: true,
          slide: '.gallery-item',
          slidesToShow: 1,
          infinite: true,
          dots: false,
          arrows: false,
          autoplay: false,
          asNavFor: '.vehicle-info-gallery-copy',
          beforeFunction: function (e, slick, currentSlide, nextSlide) {
            console.log('gallery nextslide: ', nextSlide);
            // update context for the next/prev clicks that just happened
            anAddContext(
              $('.slick-nav-container', $scope),
              blocks.listItemBlock(nextSlide)
            );
            $galleryPagerLink.removeClass('active');
            $galleryPagerLink.eq(nextSlide).addClass('active');
            // TODO: move this out to a shared function that lives in lib/animations (see inventory-detail.js)
            var $allImg = $('.gallery-item img').not('.gallery-item.slick-active img');
            gsap.TweenMax.to($allImg, 0, { scale: 1.5 });
            gsap.TweenMax.to($allImg, 0.5, { scale: 1 });
            gsap.TweenMax.to($allImg, 0.5, { scale: 1.01, delay: 0.5 });
          },

          tablet: {
            dots: false,
            autoplay: false,
            // tablet and above get these lovely prev & next arrows
            prevArrow: '<div class="carousel-prev datalayer-link"><button class="bx-prev unstyled" aria-label="show previous gallery image" tabindex="0"><i class="icon icon-arrow-thin-left"></i></button></div>',
            nextArrow: '<div class="carousel-next datalayer-link"><button class="bx-next unstyled" aria-label="show next gallery image" tabindex="0"><i class="icon icon-arrow-thin-right"></i></button></div>',
          }
        }
      });

      // gallery copy synced with gallery slider
      // Display dots and arrows on this slider and use asNavFor the top (image) slider (mobile only)
      var galleryCopy = new Slicker({
        $slider: $('.vehicle-info-gallery-copy'),
        slickOptions: {
          mobileFirst: true,
          slide: '.copy',
          slidesToShow: 1,
          infinite: true,
          dots: true,
          arrows: true,
          autoplay: false,
          fade: true,
          paddingBottom: '25px',
          asNavFor: '.vehicle-info-gallery .carousel-inner',
          beforeFunction: function (e, slick, currentSlide, nextSlide) {
            var $nextCopy = $(slick.$slides[nextSlide]);
            gsap.TweenMax.to($nextCopy, 0, { top: 7 });
            gsap.TweenMax.to($nextCopy, 0.6, { top: 0 });
          },
          tablet: {
            dots: false,
            arrows: false
          }
        }
      });

      // default component Context
      // for its pageLoad
      anAddContext(
        $scope,
        blocks.sectionBlock('Gallery'),
        blocks.seriesBlock({
          series_code: this.data.series,
          year: this.data.year,
          categories: this.data.category,
          base_msrp: this.data.defaultMsrp
        }),
        blocks.listBlock($galleryPagerLink.length, 'carousel')
      );

      // gallery-pager links context
      $galleryPagerLink.each(function (idx) {
        anAddContext(
          $(this),
          blocks.listItemBlock(idx)
        );
      });

      anClicks($scope);

      scroller.add($scope, {
        after: function () {
          anPageLoad($scope);
        }
      });
    },

    // data store for info about this vehicle, populated via models.
    data: {
      year: '',
      series: '',
      seriesSanitized: '',
      cityMpg: 0,
      hwyMpg: 0,
      trims: [''], // (each trim, we refer to a as 'model' in the UI) (CLSRest)
      sanitizedTrims: [], // grades and trims combined, the final result of 'sanitized' trims (models)
      lang: __lang,
      seats: 0,
      defaultMsrp: 0,
      tdaCode: tdaConfig.tda.code,
      zipCode: '',
      cachedDisclaimerMap: {}
    },

    populateData: function () {
      var self = this;
      var $vehicle = $('#page-vehicle-info');
      self.data.year = $vehicle.data('year');
      self.data.series = $vehicle.data('series').toString();
      self.data.zipCode = zip.getCookiedDefaultFallback();
      self.data.site_context = tdaConfig.site.context_url;

      // TODO: Redo this to use PageCache.awaitall, if that's even possible
      self.getSeries()
        .then(function getSeriesDone() {
          self.displayHeader();
          // self.data.trims and more! set via side effect of getSeries.
          var trimsArr = trimXform({
            trims: self.data.trims,
            series: self.data.series,
            seriesSanitized: self.data.seriesSanitized,
            year: self.data.year,
            cat: self.data.category
          });
          self.data.sanitizedTrims = trimsArr;

          // Add big images, plus some other horsey things
          self.getBigImages()
            .done(function getBigImagesDone() {
              var response = arguments[0];
              var trimsArrWithImages = trimXformBigImages(trimsArr, response);
              self.drawTrims(trimsArrWithImages);
            });
        })
        .catch(function (err) { console.log('err:', err); }); // eslint-disable-line no-console
    },

    // Get generic info about this series, AND get the trims for this series
    // TODO: less side effects.
    getSeries: function () {
      var self = this;
      return batws.cls().getSeriesTrimInfo({
        series_code: self.data.series, year: self.data.year
      })
        .then(function (response) {
          var curSeries = response.series;
          // add returned data to our data store
          // specific data that lives on response.series[0]:
          self.data.cityMpg = curSeries.city_mpg;
          self.data.hwyMpg = curSeries.hwy_mpg;
          if (curSeries.available_seating !== null) {
            self.data.seats = curSeries.available_seating[0];
          }
          if (curSeries.categories !== null) {
            self.data.category = curSeries.categories[0].code; // for datalayer
          }
          // TODO: get disclaimers from here instead!

          var tempDisclaimersObj = response.series.disclaimers;
          var finalDisclaimersObj = {};
          if (tempDisclaimersObj !== null) {
            for (var i = 0; i < tempDisclaimersObj.length; i++) {
              finalDisclaimersObj[tempDisclaimersObj[i].code] = {
                code: tempDisclaimersObj[i].code,
                description: tempDisclaimersObj[i].text
              };
            }
          }

          self.data.cachedDisclaimerMap = finalDisclaimersObj;

          if (curSeries.available_seating !== null) {
            if (curSeries.available_seating[0] === 3) {
              self.data.seats = 5;
            }
          }
          self.data.trims = curSeries.trims;
          self.data.defaultMsrp = readableMonetize(curSeries.base_msrp);

          PageCache.await('series.map')
            .then(function (seriesMap) {
              self.data.seriesSanitized = seriesMap[curSeries.series_code].series_display_name;
            })
            .catch(function (err) { console.error('Err: ', err); }); // eslint-disable-line no-console
        })
        .catch(function (err) {
          console.error('errr:', err); // eslint-disable-line no-console
        });
    },

    // todo: move this out, along with slideshows
    drawTrims: function (trimsArr) {
      var self = this;
      if (!self.trimsArr) {
        self.trimsArr = trimsArr;
      }

      if (self.trimsArr.length) {
        // modifies the trimArr one more time.
        // This time, we send it to vehicle.disclaimers to do TWO! things:
        // 1) Modify trim features of trimsArr, finding inline disclaimers and replacing them with HTML
        // 2) Build and return those found disclaimers
        var currentDisclaimers = this.data.cachedDisclaimerMap; // All disclaimers for the current series
        var xformedTrimDisclaimersObj = trimXformDisclaimers(currentDisclaimers, self.trimsArr);
        var finalTrimsArr = xformedTrimDisclaimersObj.xformedTrimsArr;
        var trimFeatureDisclaimers = xformedTrimDisclaimersObj.trimFeatureDisclaimers;

        // BAT-3173: Add or modify even more disclaimers for the pruis prime. Arrrgghhh.
        // TODO: move this functionality out to PriusPrime JS
        if (self.data.series === 'priusprime') {
          $.each(priusPrime.staticDisclaimers, function (idx, pruisDisclaimer) {
            if (currentDisclaimers[pruisDisclaimer]) {
              // Rejoice in this glory.
              if (pruisDisclaimer === 'prime_2018_range_rating') {
                trimFeatureDisclaimers.push({
                  service_id: currentDisclaimers.prime_2018_range_rating.code,
                  disclaimer_copy: 'Based on 2018 Prius Prime EPA-estimated combined 133 MPGe, and non-luxury plug-in hybrid segment from <a href="https://www.fueleconomy.gov" target="_blank">www.fueleconomy.gov</a>. Actual mileage will vary.'
                });
              } else if (pruisDisclaimer === 'prime_2018_ev_range') {
                trimFeatureDisclaimers.push({
                  service_id: currentDisclaimers.prime_2018_ev_range.code,
                  disclaimer_copy: '2018 Prius Prime EPA-estimated range rating when fully charged and with a full tank of gas. Excludes driving conditions. Actual mileage will vary.'
                });
              } else {
                trimFeatureDisclaimers.push({
                  service_id: currentDisclaimers[pruisDisclaimer].code,
                  disclaimer_copy: currentDisclaimers[pruisDisclaimer].description
                });
              }
            }
          });
        }

        // at times, we need to ensure disclaimers are ready before
        // we try to draw them (prius-prime, benefits page)
        // add them to PageCache simply to provide something we can listen to
        var cacheId = 'vehicle.info.localDisclaimers';
        if (!PageCache.has(cacheId) && !PageCache.isPending(cacheId)) {
          PageCache.set(cacheId, trimFeatureDisclaimers);
        }

        // sorry, but this is the sort of thing we need to face when pulling HBS out of XSL
        // I know it should be further abstracted as well, but here we are
        var trimI18n = {
          es: {
            site_context: tdaConfig.site.context_url,
            msrp: 'DESDE',
            findInventory: 'Buscar inventario',
            viewOffers: 'Ver ofertas'
          },
          en: {
            site_context: tdaConfig.site.context_url,
            msrp: 'MSRP',
            findInventory: 'Find Inventory',
            viewOffers: 'View Offers'
          }
        };

        $('#js-template-trim-output').html(__tmplTrims({
          i18n: trimI18n[__lang],
          trims: finalTrimsArr
        }));

        // Trims have drawn, do trim specific things here
        disclaimers.addVehicleInfoDisclaimers(trimFeatureDisclaimers);
        disclaimers.msrpMpgDigits('#js-template-trim-output');
        disclaimers.addLocalDisclaimers();
      } else {
        $('.nav-side a[href=#section-info-trims]').parent('li').remove();
        $('#section-info-trims').remove();
      }

      // Page is considered "DONE", so we do DONE type things.
      // These have side effects on other "components" though, so it's still awkward
      // Really we should just be doing things that affect the models slideshow area
      // also, series should be sanitized from OG CLS call, not as a result of getSeries
      $('.js-series-sanitized').html(self.data.seriesSanitized); // headline of each section
      self.addSeriesPrefix();
      self.attachListeners();
      self.setLinkChanges();
      self.handleCtasPage();

      self.slideshowModelsBuild(self.trimsArr);
      self.handleCtasTrims(self.trimsArr);

      var firstImg = new Image();
      if (self.trimsArr.length) {
        firstImg.src = self.trimsArr[0].imageLarge;
        firstImg.onload = function () {
          bat.util.loader.hideLoader(true);
        };
      } else {
        bat.util.loader.hideLoader(true);
      }
    },

    /*
      Trim (Model Slideshow) specific CTAs
      These are not Tools DCR configurable
      Need to account for inventory and offers only
    */
    handleCtasTrims: function (trimsArr) {
      var $ctaScope;
      trimsArr.forEach(function (trim) {
        $ctaScope = $('.js-model-' + trim.series + '-' + trim.model_code);
        ctas.inventory({
          series: trim.series,
          grade: trim.model_code,
          year: trim.year
        }, $ctaScope);

        ctas.offers(trim.series, $ctaScope);
      });
    },

    // Add prefix to the current vehicle (only for spanish pages)
    addSeriesPrefix: function () {
      var self = this;
      if (__lang === 'es') {
        var prefixes = {
          86: 'el',
          avalon: 'el',
          avalonhybrid: 'el',
          camry: 'el',
          camryhybrid: 'el',
          corolla: 'el',
          corollaim: 'el',
          frs: 'el',
          ia: 'el',
          im: 'el',
          prius: 'el',
          priusc: 'el',
          priusprime: 'el',
          priusv: 'el',
          tc: 'el',
          xb: 'el',
          yaris: 'el',
          yarisia: 'el',
          '4runner': 'la',
          highlander: 'la',
          highlanderhybrid: 'la',
          landcruiser: 'la',
          rav4: 'la',
          rav4hybrid: 'la',
          sequoia: 'la',
          sienna: 'la',
          tacoma: 'la',
          tundra: 'la'
        };

        $('.js-series-prefix').each(function (index, item) {
          var selectedPrefix = prefixes[self.data.series];
          if (selectedPrefix) {
            // needs to add an association
            if (!$(item).hasClass('js-prefix-simple')) {
              selectedPrefix = (selectedPrefix === 'el') ? 'del' : 'de la';
            }
            $(item).html(selectedPrefix);
          }
        });
      }
    },

    // Todo: use our api
    getBigImages: function () {
      var deferredBigImages = $.Deferred();
      $.ajax({
        type: 'GET',
        url: '/config/services/configuration/3d/getImages?brand=TOY&config=base&region=NATIONAL&year=' + this.data.year + '&series=' + this.data.series + '&appkey=QnV5IEEgVG95b3Rh'
      }).done(function (data) {
        deferredBigImages.resolve(data.DataArea.model);
      });
      return deferredBigImages.promise();
    },

    // Update Model details (header area)
    displayHeader: function () {
      var modelHeaderTemplate = $('#template-header-detail').html();
      var modelHeaderHtml = Handlebars.hcompile(modelHeaderTemplate, this.data);
      $('#js-template-header-detail').html(modelHeaderHtml);
      var localMsrp = this.data.defaultMsrp;

      // Remove top right MSRP if we don't have the data
      if (localMsrp === '0' || localMsrp.length <= 0) {
        var $header = $('.header-offer');
        $header.children('.info-msrp').fadeOut();
        $header.children('.info-note').fadeOut();
      } else {
        $('.info-msrp').html('$' + this.data.defaultMsrp);
      }

      disclaimers.msrpMpgDigits('#js-template-header-detail');
      disclaimers.msrpMpgDigits('.header-offer');

      recentVehicles.saveVehicle({
        year: this.data.year,
        series: this.data.series,
        trim: '',
        trimCode: ''
      });

      this.handleCtasHeader();
      this.getOffer();
    },

    // Get the first offer for this vehicle
    // this is our featured offer
    // TODO: Can we used cached offers, if they exist?
    getOffer: function () {
      var self = this;
      if (tdaConfig.tda.code === 'WWW') {
        self.hideOfferItems();
        $('.is-www').fadeIn('fast'); // show 'enter your zip for local offers'
        self.analyticsHeaderAndSideNav();
      } else {
        var offerUrl = '/offers-service/OFFERS/allOffers';
        var offerUrlParams = {
          pageSize: 9,
          key: tdaConfig.offers.r2_api_key,
          series: self.data.series,
          year: self.data.year,
          tdaCode: self.data.tdaCode,
          zipCode: zip.getCookiedDefaultFallback(),
          lang: self.data.lang
        };
        var offerUrlFinal = offerUrl + '?' + $.param(offerUrlParams);
        var offersHeroAjax = new AjaxOffers(offerUrlFinal, true, true, $('.header-offer'), false, false);
        offersHeroAjax.init();

        $(offersHeroAjax).on('COMPLETE', function (event, $newItems, data) {
          var firstOffer = data.items[0];
          if (data.numFound === 1) {
            self.hideOfferItems(1);
          }

          self.displayOffer(firstOffer);

          // we have an offer, add that context
          anAddContext(
            self.$header,
            blocks.offerBlock(firstOffer)
          );
          anAddContext(
            self.$sideNav,
            blocks.offerBlock(firstOffer)
          );
          self.analyticsHeaderAndSideNav();
        });

        // note: it's possible to get BOTH
        // NOT_ITEMS_FOUND and ERROR. What gives?
        $(offersHeroAjax).on('NO_ITEMS_FOUND', function () {
          self.hideOfferItems(0);
          self.analyticsHeaderAndSideNav();
        });

        $(offersHeroAjax).on('ERROR', function () {
          self.hideOfferItems(0);
          // add error block
          self.analyticsHeaderAndSideNav();
        });
      }
    },

    // Why not add the seriesBlock in displayHeader?
    // just cause we dont need it till now, doesn't mean we can't add it at seperate times
    // this becomes cumbersone though
    // Invoked within getOffer, so as we have offer data. Ya dig?
    // We've decided to tie the main nav to series and offer. Prelude to 'page-based' data
    analyticsHeaderAndSideNav: function () {
      var self = this;
      var series = {
        series_code: this.data.series,
        year: this.data.year,
        categories: this.data.category,
        base_msrp: this.data.defaultMsrp
      };

      anAddContext(
        this.$header,
        blocks.sectionBlock('Intro'),
        blocks.seriesBlock(series)
      );
      anClicks(this.$header);

      anAddContext(
        this.$sideNav,
        blocks.seriesBlock(series)
      );

      anClicks(this.$sideNav);

      scroller.add(self.$header, {
        after: function viewAfter() {
          anPageLoad(self.$header);
        }
      });

      // anPageLoad(
      //   this.$header
      // );
    },

    hideOfferItems: function (totalOffersParam) {
      var totalOffers = totalOffersParam || 0;
      var removeOfferStrip = function () {
        $('#template-offer-card').closest('.ls-cmp-wrap').remove(); // Remove entire Offers Strip component
        $('#js-offers-strip').remove(); // Remove nav item from left side nav
      };

      // if there's only a single offer, only remove the offer strip, offer nav item, and More Offer CTAs
      if (totalOffers === 1) {
        removeOfferStrip();
        // remove 'More offers' links from mobile and desktop
        $('.js-has-offer .more').remove();
        $('.header-offer.is-mobile a[data-destination="offers"]').remove();

      // otherwise, there's zero offers, remove it all
      } else {
        removeOfferStrip();
        $('.js-has-offer').remove();
      }
    },

    // NOTE: we get this data directly off of offerBundle, passed in via getOffer
    displayOffer: function (offerResult) {
      var offerType = offerResult.offerType.toLowerCase();
      var offerLink = '/' + tdaConfig.site.context_url + '/offer-detail/?offerid=' + offerResult.id;
      var offerDom = $('.info-offer');
      var offerCashAmount;
      var offerCashLabel;
      var description;

      // update our TWO 'More Offers' link,
      // replacing it with one that contains the data-layer
      // Top right (desktop)
      var linkText = $('.js-has-offer .link-with-arrow').text().trim();
      $('.js-has-offer .link-with-arrow')
        .html('<a class="datalayer-link" href="/' + tdaConfig.site.context_url + '/offers/' + this.data.series + '"><div class="icon-type icon-arrow-r"></div>' + linkText + '</a>');
      // under vehicle (Mobile)
      var linkTextMobile = $('.more .info-offers-more.js-has-offer').text().trim();
      $('.more .info-offers-more.js-has-offer')
        .replaceWith('<a href="/' + tdaConfig.site.context_url + '/offers/' + this.data.series + '" class="btn btn-secondary info-offers-more js-has-offer datalayer-link" data-destination="offers">' + linkTextMobile + '</a>');


      // do different things for different offer types
      // note: we need the single quotes inline, around our data-layer attr
      /*---------------------------------------------------------------------
      Multi: (the offers service calls them cash, but they have a diff offerBundle)
      ---------------------------------------------------------------------*/
      if (offerResult.multivehicle) {
        offerCashAmount = offerResult.multivehicle.amount; // BAT-5019. value has already been passed through readableMonetize.
        offerCashLabel = offerResult.multivehicle.label;

        offerDom.html('<a class="datalayer-link" href="' + offerLink + '">$' + offerCashAmount + ' ' + offerCashLabel + '</a>');

      /*---------------------------------------------------------------------
      CASH:
      ---------------------------------------------------------------------*/
      } else if (offerType === 'cash') {
        offerCashAmount = offerResult.cash.amount; // BAT-5019. value has already been passed through readableMonetize.
        offerCashLabel = offerResult.cash.label;
        var extraCashAmount = offerResult.extraCashAmount; // BAT-5019. value has already been passed through readableMonetize.

        // If this Cash Offer contains Bonus Cash:
        if (extraCashAmount) {
          offerDom.html('<a class="datalayer-link" href="' + offerLink + '">$' + offerCashAmount + ' ' + offerCashLabel + ' + $' + extraCashAmount + ' ' + offerCashLabel + '</a>');
        } else {
          offerDom.html('<a class="datalayer-link" href="' + offerLink + '">$' + offerCashAmount + ' ' + offerCashLabel + '</a>');
        }
      /*---------------------------------------------------------------------
      APR
      ---------------------------------------------------------------------*/
      } else if (offerType === 'apr') {
        var aprTermObj = offerResult.tiers[0].term[0];
        var offerAprRate = aprTermObj.rate;
        var offerAprDuration = aprTermObj.duration;
        var aprExtraCashAmount = aprTermObj.extraCashAmount;

        if (aprExtraCashAmount) {
          offerDom.html('<a class="datalayer-link" href="' + offerLink + '">' + offerAprRate + '% ' + offerType + ' for ' + offerAprDuration + ' months + $' + aprExtraCashAmount + ' Cash</a>');
        } else {
          offerDom.html('<a class="datalayer-link" href="' + offerLink + '">' + offerAprRate + '% ' + offerType + ' for ' + offerAprDuration + ' months</a>');
        }
      /*---------------------------------------------------------------------
      LEASE
      ---------------------------------------------------------------------*/
      } else if (offerType === 'lease') {
        var leaseTermObj = offerResult.tiers[0].term[0];
        var leaseMonthPay = leaseTermObj.monthlyPayment;
        var leaseDuration = leaseTermObj.duration;
        var leaseExtraCashAmount = leaseTermObj.extraCashAmount;

        // If this Lease Offer contains Bonus Cash:
        if (leaseExtraCashAmount) {
          offerDom.html('<a class="datalayer-link" href="' + offerLink + '">$' + readableMonetize(leaseMonthPay) + ' a month, for ' + leaseDuration + ' months + Bonus Cash</a>');
        } else {
          offerDom.html('<a class="datalayer-link" href="' + offerLink + '">$' + readableMonetize(leaseMonthPay) + ' a month, for ' + leaseDuration + ' months</a>');
        }
      /*---------------------------------------------------------------------
      MISC
      ---------------------------------------------------------------------*/
      } else if (offerType === 'misc') {
        description = offerResult.miscellaneous.title;
        if (!description) {
          description = offerResult.description;
        }
        offerDom.html('<a class="datalayer-link" href="' + offerLink + '">' + description + '</a>');
      /*---------------------------------------------------------------------
      MSRP
      ---------------------------------------------------------------------*/
      } else if (offerType === 'msrp') {
        description = offerResult.description;
        if (!description) {
          description = offerResult.msrp.title;
        }
        offerDom.html('<a class="datalayer-link" href="' + offerLink + '">' + description + '</a>');
      }
    },

    // Header specific CTAs
    // Configurable via Tools DCR, need to account for ALL possible CTAS
    handleCtasHeader: function () {
      var $ctaScope = this.$header;
      ctas.compare(this.data.year, this.data.series, $ctaScope);
      ctas.inventory({
        series: this.data.series,
        year: this.data.year
      }, $ctaScope);
      ctas.dealBuilder(this.data.year, this.data.series, $ctaScope);
      ctas.offers(this.data.series, $ctaScope);
      ctas.dealerSite($ctaScope);

      // kick it old school. Not yet accounted for in our newer CTAs
      // but this does NOT have to be done at the page level, just doing it on the header is good
      $("a[data-destination='custom']", $ctaScope).each(function () {
        var $this = $(this);
        var customUrl = $this.attr('href');
        var customUrlArr = customUrl.split('/');
        if (customUrlArr[1] == 'sites') {
          customUrlArr.splice(0, 3);
          customUrlArr.unshift('/' + tdaConfig.site.context_url);
        }
        var finalUrl = customUrlArr.join('/'); // create URL from array
        // console.log("finalUrl: " + finalUrl);
        $this.attr('href', finalUrl);
      });
      // TODO: test this
      $('a', $ctaScope).each(function () {
        $(this).addClass('datalayer-link');
      });
    },

    addSpecContext: function () {
      var $scope = this.$vehicleSpecs;
      anAddContext(
        $scope,
        blocks.sectionBlock('Features and Specifications'),
        blocks.seriesBlock({
          series_code: this.$vehicleSpecs.data('series'),
          year: this.$vehicleSpecs.data('year')
        })
      );
      anClicks($scope);
      scroller.add($scope, {
        after: function () {
          anPageLoad($scope);
        }
      });
    },
    // TODO: move this out to vehicle-info-feature-video
    // BAT-3428 Adding support for videos to featured panels
    // if one of the feature src files in the DCR is a video
    // loop through the featured panels and find out which row has the video:
    //     hide the image in the featured panel
    //     display the video in the featured panel
    //     set the source type (based on the file extension) and play the video
    enableFeatureVideo: function () {
      var self = this;
      // loop through each feature row
      $('.specs-row').each(function (index, item) {
        // grab the image src (this comes from the VehicleInfo drc)
        var fileSrc = $(this).find('img').attr('src');
        // console.log(fileSrc);
        // check if the src is a supported video file
        //     * BAT-3549 - now check if the field contains a YouTube link
        var fileExt = '';
        var srcType = '';
        var isYouTubeLink = (fileSrc != null && fileSrc.indexOf('youtube.com') >= 0);
        // console.log("isYouTubeLink: " + isYouTubeLink);
        if (fileSrc && !isYouTubeLink) {
          fileExt = fileSrc.substr(fileSrc.lastIndexOf('.') + 1);
          srcType = self.getSourceForVideoType(fileExt);
        }

        // Check if the link is YouTube, follow the same pattern
        // as below for uploaded videos:
        //     1) hide the img
        //     2) set the attributes
        //     3) unhide the iframe (or video) object
        // Note: <object> and <embed> are currently depricated
        if (isYouTubeLink) {
          $(this).find('img').hide();
          var iframe;
          if (responsive() === 'sm') {
            iframe = $(this).find('iframe').get(0);
          } else {
            if ($(this).find('iframe').length > 1) {
              iframe = $(this).find('iframe').get(1);
            } else {
              iframe = $(this).find('iframe').get(0);
            }
          }

          var videoId = self.getYouTubeVideoId(fileSrc);
          // console.log(videoId);

          // add params for autoplay, mute, loop, playsinline, and controls
          fileSrc = fileSrc + '?autoplay=1&mute=1&loop=1&playsinline=1&controls=0';
          // need playlist parameter with video ID in order for the
          // video to loop (it won't work without playlist param)
          if (videoId) {
            fileSrc = fileSrc + '&playlist=' + videoId;
          }
          iframe.setAttribute('src', fileSrc);
          iframe.removeAttribute('style');
        } else {
          // if the src is a supported video file type or YouTube link,
          // hide the image and show the video (these tags are in
          // Vehicle-Info-Bottom.xsl)
          if (['mp4', 'ogv', 'ogg', 'webm'].indexOf(fileExt) >= 0) {
            // console.log('video file found: show, load, and play');

            // hide the img tags in this featured panel since we
            // will be displaying video
            $(this).find('img').hide();

            // there are two video tags in the specs-row div depending
            // on the screen size, since we autoplay and loop, need to
            // find the correct video to play

            // as per the XSL, the first one is sm and the second one
            // is md/lg, so we don't need to guess, so our algorithm is:
            //    sm = get(0)
            //    everything else = get(1)

            if (responsive() === 'sm') {
              var video = $(this).find('video').get(0);
              if (video) {
                // video.style.display = 'block';
                video.removeAttribute('style');
                video.getElementsByTagName('source')[0].setAttribute('type', srcType);
                // load the video
                video.load();
              }
            } else { // md and lg breakpoints
              // double check if there are two video tags first, there
              // ALWAYS should be, but at least we can minimize problems
              // if something weird happens
              if ($(this).find('video').length > 1) {
                var video = $(this).find('video').get(1);
                if (video) {
                  // video.style.display = 'block';
                  video.removeAttribute('style');
                  video.getElementsByTagName('source')[0].setAttribute('type', srcType);
                  // load the video
                  video.load();
                }
              } else {
                // overprotective fallback, this should not happen
                var video = $(this).find('video').get(0);
                if (video) {
                  // video.style.display = 'block';
                  video.removeAttribute('style');
                  video.getElementsByTagName('source')[0].setAttribute('type', srcType);
                  // load the video
                  video.load();
                }
              }
            }
          } else {
            // console.log('no video files found');
          } // end if mp4 webm etc check
        } // end if isYouTubeLink
      });
    },

    // simple method to get the video source type based
    // on the file extension
    getSourceForVideoType: function (fileExt) {
      switch (fileExt) {
        case 'mp4':
          return 'video/mp4';
        case 'webm':
          return 'video/webm';
        case 'ogg':
          return 'video/ogg';
        case 'ogv':
          return 'video/ogg';
        default:
          return '';
      }
    },

    // get the YouTube video ID from the url
    // https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
    getYouTubeVideoId: function (url) {
      var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length == 11) {
        return match[2];
      }
    }
  };

  return vehicleInfo;
});

